export enum CFDClientEvent {
    OnReceiveMessage = 'OnReceiveMessage',
}
export enum CFDInvokeAction {
    SendMessageToPOS = 'SendMessageToPOS',
    ConnectWithPOS = 'ConnectWithPOS',
    OnDisconnectedAsync = 'OnDisconnectedAsync',
    ConnectWithPOSUsingCode = 'ConnectWithPOSUsingCode',
    ConnectWithPOSUsingToken = 'ConnectWithPOSUsingToken',
}
export interface CodeResult {
    clientID: string
    code: string
    cfdConnectionID: string
}
